import React from 'react';

export default function Badge({ variant = 'neutral', icon, children, className = '' }) {
  const variants = {
    insight: 'bg-teal-50 text-teal-700 border-teal-200',
    decision: 'bg-blue-50 text-blue-800 border-blue-200',
    risk: 'bg-amber-50 text-amber-700 border-amber-200',
    outcome: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    ai: 'bg-purple-50 text-purple-700 border-purple-200',
    critical: 'bg-red-50 text-red-700 border-red-200',
    neutral: 'bg-slate-100 text-slate-700 border-slate-200',
  };

  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium border rounded-md ${variants[variant]} ${className}`}>
      {icon}
      {children}
    </span>
  );
}